import EzController from 'controllers/ez-base-controller';
import 'dom-slider';

const { slideUp } = window.domSlider;

export default class FlashMessageController extends EzController {
  connect() {
    if (this.element.classList.contains('ez-flash-message--auto-dismiss')) {
      setTimeout(() => {
        this.dismiss();
      }, 3000);
    }
    this.flagLoaded();
  }

  dismiss() {
    slideUp({ element: this.element });
  }
}
